import React, { useState } from "react";
import { Container, Row, Form } from "react-bootstrap";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import TextField from "components/Atoms/TextField";
import { Auth } from "aws-amplify";
import storage from "helpers/storage";
import { triggerUxCritialErrors } from "actions/error";
import { useAppDispatch } from "store/store";
import { useHistory } from "react-router-dom";
import { LoadingButton } from "@mui/lab";

const forgotPasswordSchema = yup.object().shape({
  username: yup
    .string()
    .email("Username must be in abc@def.com format")
    .min(7, "Username should have atleast 7 characters")
    .max(50, "Username should not exceed above 50 characters")
    .required("Username is required"),
});

function ForgotPassword(props) {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
  });

  const onSubmit = (data) => {
    setIsLoading(true);
    const { username } = data;

    Auth.forgotPassword(username)
    .then((data) => {
      storage.set("userEmail", username, "local");
      setIsLoading(false);

      // redirect to forgot password verify
      history.push('/verify', {username});
    })
    .catch((err) => {
      console.log(err);
      setIsLoading(false);
      triggerUxCritialErrors(err, dispatch);
    });
  }

  return (
    <Container fluid className="login_container_forget">
      <Row className="login_title">
        <span>Let's Get Started!</span>
      </Row>
      <Row className="login_box">
        <span>Forgot Password?</span>
        <div>
          <Form className="login_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="returning_customer_container">
              <div className="input_fields forgot-password">
                <Controller
                  name="username"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      autoFocus={true}
                      error={Boolean(errors.username)}
                      fullWidth
                      placeholder="Your User ID"
                      label="Your User ID"
                      helperText={errors.username?.message}
                    />
                  )}
                />
              </div>
              <LoadingButton
                loading={isLoading}
                variant="contained"
                color="primary"
                type="submit"
                size="large"
                fullWidth
                loadingPosition="start"
              >
                {`${ isLoading ? 'Sending...' : 'Send code'}`}
              </LoadingButton>
              <div className="go-back-link">
                Go back?{" "}
                <a href="/login">
                  Click here
                </a>
              </div>
            </div>
          </Form>
        </div>
      </Row>
    </Container>
  );
}
export default ForgotPassword;
